<template>
    <div>
      <Navbar />
  
      <main>
  
        <!-- ── Page hero ── -->
        <section class="page-hero">
          <div class="page-hero-overlay"></div>
          <div class="page-container">
            <div class="page-hero-content">
              <div class="hero-badge">
                <font-awesome-icon icon="cookie-bite" class="me-1" /> Legal
              </div>
              <h1 class="page-hero-title">Cookie Policy</h1>
              <nav class="breadcrumb-nav" aria-label="Breadcrumb">
                <router-link to="/home" class="breadcrumb-link">Home</router-link>
                <span class="breadcrumb-sep">/</span>
                <span class="breadcrumb-current">Cookie Policy</span>
              </nav>
            </div>
          </div>
        </section>
  
        <!-- ── Content ── -->
        <section class="section-pad">
          <div class="page-container">
            <div class="content-layout">
  
              <!-- ── Sidebar ── -->
              <aside class="toc-sidebar" aria-label="Page sections">
                <div class="toc-card">
                  <div class="toc-title">
                    <font-awesome-icon icon="list-ul" class="me-1" /> On this page
                  </div>
                  <nav class="toc-links">
                    <a href="#cookie-content" class="toc-link toc-link--active">Cookie Policy</a>
                    <router-link to="/privacy-policy" class="toc-link">Privacy Policy</router-link>
                    <router-link to="/terms-and-conditions" class="toc-link">Terms &amp; Conditions</router-link>
                  </nav>
                  <div class="toc-meta">
                    <font-awesome-icon icon="calendar-alt" class="me-1" />
                    Last updated: {{ currentYear }}
                  </div>
                </div>
  
                <div class="contact-card">
                  <div class="contact-card-icon">
                    <font-awesome-icon icon="envelope" />
                  </div>
                  <p class="contact-card-text">Questions about our cookie use?</p>
                  <router-link to="/contact" class="contact-card-link">Contact us</router-link>
                </div>
              </aside>
  
              <!-- ── Main content ── -->
              <div class="policy-content-wrap">
  
                <!-- Loading -->
                <div v-if="loading" class="loading-state">
                  <div class="spinner-border text-primary" style="width:2.5rem;height:2.5rem;" role="status"></div>
                  <p class="loading-text">Loading cookie policy...</p>
                </div>
  
                <!-- Content -->
                <div v-else class="policy-card" id="cookie-content">
                  <div v-if="details.cookie_policy" class="policy-body" v-html="details.cookie_policy"></div>
                  <div v-else class="empty-state">
                    <font-awesome-icon icon="cookie-bite" class="empty-icon" />
                    <p>Cookie policy content is not yet available.</p>
                  </div>
                </div>
  
              </div>
            </div>
          </div>
        </section>
  
      </main>
  
      <Footer />
    </div>
  </template>
  
  <script>
  import axios  from 'axios';
  import Navbar from '../components/Navbar';
  import Footer from '../components/footer';
  
  export default {
    name: 'CookiePolicy',
  
    components: { Navbar, Footer },
  
    data() {
      return {
        details: {},
        loading: true,
      };
    },
  
    computed: {
      currentYear() {
        return new Date().getFullYear();
      },
    },
  
    methods: {
      pageData() {
        axios.get('/admin/fetchProjectSetup')
          .then(({ data }) => { this.details = data.data; })
          .catch(() => {})
          .finally(() => { this.loading = false; });
      },
    },
  
    mounted() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      this.pageData();
    },
  };
  </script>
  
  <style scoped>
  /* ── Shared ──────────────────────────────────────────────────────────── */
  .page-container { max-width:1160px; margin:0 auto; padding:0 24px; }
  .section-pad    { padding:64px 0 80px; }
  .me-1           { margin-right:5px; }
  
  /* ── Page hero ───────────────────────────────────────────────────────── */
  .page-hero {
    position: relative;
    background: linear-gradient(135deg, #051B35 0%, #004AAD 100%);
    padding: 80px 0 56px;
    overflow: hidden;
  }
  .page-hero::before {
    content: '';
    position: absolute;
    inset: 0;
    background: url('/static/img/banner-bg-5.jpg') center/cover no-repeat;
    opacity: 0.05;
  }
  .page-hero-overlay {
    position: absolute;
    inset: 0;
    background: linear-gradient(135deg, rgba(5,27,53,.95) 0%, rgba(0,74,173,.78) 100%);
  }
  .page-hero-content  { position:relative; z-index:1; text-align:center; }
  
  .hero-badge {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    background: rgba(255,255,255,.1);
    border: 1px solid rgba(255,255,255,.18);
    color: rgba(255,255,255,.9);
    border-radius: 20px;
    padding: 4px 14px;
    font-size: 12px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: .07em;
    margin-bottom: 16px;
  }
  
  .page-hero-title    { font-size:clamp(28px,5vw,44px); font-weight:800; color:#fff; margin:0 0 18px; letter-spacing:-.01em; }
  .breadcrumb-nav     { display:inline-flex; align-items:center; gap:8px; font-size:14px; }
  .breadcrumb-link    { color:rgba(255,255,255,.65); text-decoration:none; transition:color .15s; }
  .breadcrumb-link:hover { color:#fff; }
  .breadcrumb-sep     { color:rgba(255,255,255,.3); }
  .breadcrumb-current { color:rgba(255,255,255,.45); }
  
  /* ── Layout ──────────────────────────────────────────────────────────── */
  .content-layout { display:grid; grid-template-columns:240px 1fr; gap:32px; align-items:start; }
  
  /* ── Sidebar ─────────────────────────────────────────────────────────── */
  .toc-sidebar { display:flex; flex-direction:column; gap:16px; position:sticky; top:88px; }
  
  .toc-card    { background:#fff; border:1px solid #e4eaf2; border-radius:12px; padding:20px; }
  .toc-title   { font-size:12px; font-weight:700; text-transform:uppercase; letter-spacing:.07em; color:#7a90b0; margin-bottom:14px; display:flex; align-items:center; }
  .toc-links   { display:flex; flex-direction:column; gap:2px; margin-bottom:16px; }
  .toc-link    { display:block; padding:7px 10px; border-radius:7px; font-size:13.5px; color:#4a5568; text-decoration:none; transition:all .14s; }
  .toc-link:hover { background:#f4f7fb; color:#004AAD; }
  .toc-link--active { background:rgba(0,74,173,.08); color:#004AAD; font-weight:600; }
  .toc-meta    { font-size:12px; color:#b0bdd0; display:flex; align-items:center; gap:5px; padding-top:14px; border-top:1px solid #f0f4f8; }
  
  .contact-card      { background:#004AAD; border-radius:12px; padding:20px; text-align:center; }
  .contact-card-icon { width:40px; height:40px; background:rgba(255,255,255,.15); border-radius:50%; display:flex; align-items:center; justify-content:center; color:#fff; font-size:16px; margin:0 auto 12px; }
  .contact-card-text { font-size:13px; color:rgba(255,255,255,.8); margin:0 0 12px; line-height:1.5; }
  .contact-card-link { display:inline-block; background:#fff; color:#004AAD; font-size:13px; font-weight:700; padding:7px 18px; border-radius:8px; text-decoration:none; transition:background .15s; }
  .contact-card-link:hover { background:#e8f0fb; }
  
  /* ── Policy card ─────────────────────────────────────────────────────── */
  .policy-card { background:#fff; border:1px solid #e4eaf2; border-radius:14px; overflow:hidden; }
  
  /* ── Loading ─────────────────────────────────────────────────────────── */
  .loading-state { display:flex; flex-direction:column; align-items:center; padding:80px 0; gap:16px; background:#fff; border:1px solid #e4eaf2; border-radius:14px; }
  .loading-text  { font-size:14px; color:#7a90b0; margin:0; }
  
  /* ── Empty state ─────────────────────────────────────────────────────── */
  .empty-state { display:flex; flex-direction:column; align-items:center; padding:80px 24px; text-align:center; color:#7a90b0; }
  .empty-icon  { font-size:36px; margin-bottom:16px; opacity:.3; }
  
  /* ── Policy body ─────────────────────────────────────────────────────── */
  .policy-body { padding:40px 48px; font-size:15px; line-height:1.8; color:#374151; }
  
  .policy-body :deep(h1),
  .policy-body :deep(h2),
  .policy-body :deep(h3),
  .policy-body :deep(h4) { color:#1a2b45; font-weight:700; margin:32px 0 12px; line-height:1.3; }
  .policy-body :deep(h1) { font-size:26px; padding-bottom:12px; border-bottom:2px solid #e4eaf2; }
  .policy-body :deep(h2) { font-size:20px; }
  .policy-body :deep(h3) { font-size:17px; }
  .policy-body :deep(p)  { margin:0 0 16px; }
  .policy-body :deep(ul),
  .policy-body :deep(ol) { padding-left:22px; margin:0 0 16px; }
  .policy-body :deep(li) { margin-bottom:6px; }
  .policy-body :deep(a)  { color:#004AAD; text-decoration:underline; }
  .policy-body :deep(a:hover) { color:#003b8e; }
  .policy-body :deep(strong) { color:#1a2b45; font-weight:700; }
  .policy-body :deep(blockquote) {
    border-left: 3px solid #004AAD;
    background: #f4f7ff;
    padding: 14px 20px;
    border-radius: 0 8px 8px 0;
    margin: 20px 0;
    font-style: italic;
    color: #4a5568;
  }
  .policy-body :deep(hr) { border:none; border-top:1px solid #e4eaf2; margin:28px 0; }
  
  /* ── Responsive ──────────────────────────────────────────────────────── */
  @media (max-width:900px) {
    .content-layout { grid-template-columns:1fr; }
    .toc-sidebar    { position:static; }
  }
  @media (max-width:600px) {
    .section-pad    { padding:40px 0 60px; }
    .policy-body    { padding:24px 20px; }
    .page-hero      { padding:64px 0 44px; }
  }
  </style>